import initSharedPromotion from '@resources/js/components/promotion/initSharedPromotion'
import scrollToElement from '@resources/js/ui/scroll-to-element'
import inViewport from '@resources/js/helpers/inViewport'
import MapView from '@resources/js/maps/MapView'
import MapHotelsStore from '@resources/js/maps/MapStores/MapHotelsStore'
import Modal from '@resources/js/ui/Modal'
import { initShareBtn } from '@resources/js/helpers/initShareBtn'
import { createMarkerTemplate } from '@resources/js/maps/helpers'
import '@resources/js/analytics'

initSharedPromotion()

// Navigation scroll
const navItems = document.querySelectorAll('.js-nav-item')

navItems.forEach(item => {
    item.addEventListener('click', () => {
        const navTarget = document.querySelector(item.dataset.target);
        scrollToElement(navTarget, {top: 120})
    })
})

// Social networks popup
new Modal('.js-networks-popup', { trigger: '.js-networks', lockScroll: false })

// Share button
const shareBtn = document.querySelector('.js-share-btn')
initShareBtn(shareBtn)

// description toggle
inViewport('.js-desc-text', async () => {
    const { default: Toggle } = await import('@resources/js/ui/Toggle')

    new Toggle('.js-desc-btn', { target: '.js-desc-text' })
})

inViewport("#mapbox", () => {
    const map = new MapView({ zoom: 12 })
    const mapHotelsStore = new MapHotelsStore()
    const hotelsData = mapHotelsStore.getData()

    map.addMarkers(hotelsData, createMarkerTemplate)
    map.fitByCoords(mapHotelsStore.getCoordinates())
})
